import { Check } from "lucide-react";
import { cn } from "@/lib/utils";

const STEPS = ["Anmelden", "Bezahlen", "Sitzplatz wählen"];

interface RegistrationStepsProps {
  currentStep: number;
}

export default function RegistrationSteps({ currentStep }: RegistrationStepsProps) {
  return (
    <ol className="flex items-center w-full">
      {STEPS.map((label, i) => {
        const step = i + 1;
        const isCompleted = step < currentStep;
        const isActive = step === currentStep;
        const isLast = step === STEPS.length;

        return (
          <li key={label} className={cn("flex items-center", !isLast && "flex-1")}>
            <div className="flex items-center gap-2">
              <span
                className={cn(
                  "flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-xs font-semibold border",
                  isCompleted && "bg-primary border-primary text-primary-foreground",
                  isActive && "border-primary text-primary",
                  !isCompleted && !isActive && "border-muted-foreground/30 text-muted-foreground",
                )}
              >
                {isCompleted ? <Check className="h-4 w-4" /> : step}
              </span>
              <span className={cn("text-sm font-medium whitespace-nowrap", !isCompleted && !isActive && "text-muted-foreground")}>{label}</span>
            </div>
            {!isLast && <div className={cn("mx-3 h-px flex-1", isCompleted ? "bg-primary" : "bg-border")} />}
          </li>
        );
      })}
    </ol>
  );
}
